export default __webpack_public_path__ + "static/media/arrow-gif.de0032f2.gif";